import { ENVIRONMENT } from '../../constants';
import getEnvVariable from '../environment';

const showFreeTrialOnboarding = () => {
  return getEnvVariable(ENVIRONMENT.SHOW_FREE_TRIAL_ONBOARDING) === 'true';
};

export default showFreeTrialOnboarding;
